export default __webpack_public_path__ + "static/media/logo.bad95a46.svg";